import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhuyi",
  "use": "icon-zhuyi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zhuyi\"><path d=\"M512 512m-450.56 0a450.56 450.56 0 1 0 901.12 0 450.56 450.56 0 1 0-901.12 0Z\" fill=\"#ff0000\" /><path d=\"M512 716.8a40.96 40.96 0 1 1 0 81.92 40.96 40.96 0 0 1 0-81.92z m0-491.52a40.96 40.96 0 0 1 40.96 40.96v348.16a40.96 40.96 0 1 1-81.92 0V266.24a40.96 40.96 0 0 1 40.96-40.96z\" fill=\"#FFFFFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol